import { isBefore } from 'date-fns';

import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const ADVENT_2025_CAMPAIGN_END_DATE = d(2025, 12, 24, 0);

export const advent2025DrawDates = Array.from({ length: 24 }, (_, i) => d(2025, 12, i + 1, 12));

export const getNextAdvent2025DrawDate = () => {
  const now = new Date();
  return advent2025DrawDates.find((date) => isBefore(now, date)) || advent2025DrawDates.at(-1)!;
};
